import { render } from "./IaCPage.vue?vue&type=template&id=5727c2f6&scoped=true"
import script from "./IaCPage.vue?vue&type=script&lang=js"
export * from "./IaCPage.vue?vue&type=script&lang=js"

import "./IaCPage.vue?vue&type=style&index=0&id=5727c2f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5727c2f6"]])

export default __exports__